package com.evoapps.evoshift.widgets

import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.HelpOutline
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.handCursor
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.help_about
import evoshift.composeapp.generated.resources.help_got_it
import org.jetbrains.compose.resources.stringResource

/**
 * A small "?" next to a setting: opens a short explanation of [title] ([text]: what it does and
 * when to change it) in a compact dialog with a single "Got it". Described "Help: <title>" for
 * screen readers and the UI tests.
 */
@Composable
fun HelpButton(
    title: String,
    text: String,
    modifier: Modifier = Modifier,
    tint: Color = DeepNavy.copy(alpha = 0.6f)
) {
    var open by rememberSaveable { mutableStateOf(false) }
    IconButtonWithTooltip(onClick = { open = true }, modifier = modifier.size(32.dp).handCursor(), tooltip = stringResource(Res.string.help_about, title)) {
        Icon(
            Icons.AutoMirrored.Filled.HelpOutline,
            contentDescription = stringResource(Res.string.help_about, title),
            tint = tint,
            modifier = Modifier.size(18.dp)
        )
    }
    if (open) {
        EvoDialog(
            title = title,
            icon = Icons.AutoMirrored.Filled.HelpOutline,
            onDismiss = { open = false },
            width = DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.help_got_it), { open = false }),
            dismiss = null
        ) {
            Text(text, style = MaterialTheme.typography.bodyLarge, color = Color.White.copy(alpha = 0.85f))
        }
    }
}

/**
 * [HelpButton] as an action of the shared top bar (SH-89): the same "Help: <title>" explanation;
 * the dialog is hosted here, the button by the bar.
 */
@Composable
fun helpExplainerAction(title: String, text: String): TopBarAction {
    var open by rememberSaveable { mutableStateOf(false) }
    if (open) {
        EvoDialog(
            title = title,
            icon = Icons.AutoMirrored.Filled.HelpOutline,
            onDismiss = { open = false },
            width = DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.help_got_it), { open = false }),
            dismiss = null
        ) {
            Text(text, style = MaterialTheme.typography.bodyLarge, color = Color.White.copy(alpha = 0.85f))
        }
    }
    return TopBarAction(stringResource(Res.string.help_about, title), Icons.AutoMirrored.Filled.HelpOutline, { open = true })
}
